/* EclatDent — fiche produit immersive : buy box, abonnement, galerie, sticky, reveals */
(() => {
  if (window.__edfInit) return;
  window.__edfInit = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // — Apparitions au scroll du bas d'accueil (.eda-reveal), indépendant de la fiche —
  const edaReveals = document.querySelectorAll('.eda-reveal');
  if (edaReveals.length) {
    if (reduced) {
      edaReveals.forEach((el) => el.classList.add('in'));
    } else {
      const edaIO = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); edaIO.unobserve(e.target); } });
      }, { threshold: 0.15 });
      edaReveals.forEach((el) => edaIO.observe(el));
    }
  }

  // — 03/11 (vitesse) : images décoratives sous le héros chargées à l'approche (400 px), jamais avant la photo LCP —
  const tard = document.querySelectorAll('[data-ed-tard]');
  if (tard.length) {
    const charger = (el) => {
      if (el.dataset.srcset) el.srcset = el.dataset.srcset;
      if (el.dataset.src) el.src = el.dataset.src;
      if (el.dataset.bg) el.style.setProperty('--img', 'url("' + el.dataset.bg + '")');
      el.removeAttribute('data-ed-tard');
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { charger(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '400px 0px' });
      tard.forEach((el) => io.observe(el));
    } else tard.forEach(charger);
  }

  const root = document.querySelector('[data-edf]');
  if (!root) return;

  // Chaînes traduites injectées par la section (locales/*.json, ed.fiche.js_*)
  const T = {
    added: root.dataset.tAdded || 'Ajouté ✓',
    error: root.dataset.tError || 'Erreur',
    addFail: root.dataset.tAddFail || 'Impossible d’ajouter au panier : ',
    retry: root.dataset.tRetry || 'réessaie dans un instant.',
    duoFail: root.dataset.tDuoFail || 'Impossible d’ajouter le duo. Réessaie dans un instant.',
    confirmSub: root.dataset.tConfirmSub || 'Confirmer l’abonnement · ',
    chooseFreq: root.dataset.tChooseFreq || 'Choisis une fréquence ↑',
  };

  // — Ajout panier (AJAX, sans redirection) —
  function addToCart(variantId, qty, sellingPlan) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: String(variantId), quantity: Number(qty) || 1, selling_plan: sellingPlan || null }] }),
    }).then((r) => r.json().then((data) => {
      if (!r.ok || (data && data.status)) {
        throw new Error((data && (data.description || data.message)) || 'Ajout impossible');
      }
      // tout ajout réussi ouvre le tiroir upsell global et met à jour le badge header
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return data;
    }));
  }

  // — Buy box —
  const buybox = root.querySelector('[data-edf-buybox]');
  const popup = root.querySelector('[data-edf-popup]');
  if (buybox) {
    const qtyInput = buybox.querySelector('input[name="quantity"]');
    const planInput = buybox.querySelector('input[name="selling_plan"]');
    const subBtn = buybox.querySelector('[data-edf-sub-btn]');
    const subWrap = buybox.querySelector('[data-edf-sub-wrap]');
    const addBtn = buybox.querySelector('[data-edf-add]');
    const plans = [...buybox.querySelectorAll('.edf-plan')];
    const clampQty = (v) => Math.max(1, Math.min(99, parseInt(v, 10) || 1));
    let chosenPlan = '', chosenPrice = '', subOpen = false;

    // 03/11 (point 8) : « − » signalé inactif à 1 (aria-disabled, il reste focalisable)
    const moins = buybox.querySelector('[data-delta="-1"]');
    const majMoins = () => { if (moins) moins.setAttribute('aria-disabled', String(clampQty(qtyInput.value) <= 1)); };
    buybox.querySelectorAll('[data-delta]').forEach((b) => b.addEventListener('click', () => {
      qtyInput.value = clampQty(Number(qtyInput.value) + Number(b.dataset.delta));
      majMoins();
    }));
    qtyInput.addEventListener('change', () => { qtyInput.value = clampQty(qtyInput.value); majMoins(); });
    majMoins();

    function updateSubCta() {
      if (!subOpen) { subBtn.textContent = subBtn.dataset.labelClosed; subBtn.disabled = false; return; }
      if (chosenPlan) { subBtn.textContent = T.confirmSub + chosenPrice; subBtn.disabled = false; }
      else { subBtn.textContent = T.chooseFreq; subBtn.disabled = true; }
    }
    if (subBtn && subWrap) {
      subBtn.addEventListener('click', () => {
        if (!subOpen) { subOpen = true; subWrap.classList.add('open'); subWrap.setAttribute('aria-hidden', 'false'); updateSubCta(); return; }
        if (chosenPlan) buybox.requestSubmit();
      });
      plans.forEach((p) => p.addEventListener('click', () => {
        plans.forEach((x) => x.classList.remove('active'));
        p.classList.add('active');
        const r = p.querySelector('input[type="radio"]');
        if (r) r.checked = true;
        chosenPlan = p.dataset.plan || '';
        chosenPrice = p.dataset.price || '';
        planInput.value = chosenPlan;
        updateSubCta();
      }));
    }
    if (addBtn) addBtn.addEventListener('click', () => {
      planInput.value = ''; chosenPlan = '';
      if (subOpen) { subOpen = false; subWrap.classList.remove('open'); subWrap.setAttribute('aria-hidden', 'true'); plans.forEach((p) => p.classList.remove('active')); updateSubCta(); }
    });

    buybox.addEventListener('submit', (e) => {
      e.preventDefault();
      const vid = buybox.querySelector('input[name="id"]').value;
      addToCart(vid, clampQty(qtyInput.value), planInput.value || null)
        .catch((err) => { alert(T.addFail + ((err && err.message) || T.retry)); });
    });
  }
  if (popup) {
    popup.querySelectorAll('[data-edf-popup-close]').forEach((b) => b.addEventListener('click', () => popup.classList.remove('show')));
    popup.addEventListener('click', (e) => { if (e.target === popup) popup.classList.remove('show'); });
  }

  // — Duo 1 clic : ajoute le tube courant + son complément (2 tubes = livraison offerte) —
  // `[data-edf-lot-add]` (20/09/2026) : même mécanique pour un lot qui est UN produit
  // (le trio du même parfum), donc une seule variante — d'où le seuil à 1 et non 2.
  root.querySelectorAll('[data-edf-duo-add], [data-edf-lot-add]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const ids = (btn.dataset.variants || '').split(',').filter(Boolean);
      if (ids.length < 1) return;
      // Le palier « trio » est un <a> pour rester crawlable : on retient la navigation,
      // sauf si le visiteur demande explicitement un nouvel onglet.
      if (btn.tagName === 'A') {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
      }
      // `disabled` n'existe pas sur un <a> : on garde un verrou propre à l'élément,
      // sinon un double clic ajouterait deux fois le lot.
      if (btn.dataset.busy === '1') return;
      btn.dataset.busy = '1';
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
      }).then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(() => {
        alert(T.duoFail);
      }).finally(() => {
        delete btn.dataset.busy;
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('disabled');
        btn.classList.remove('is-busy');
      });
    });
  });

  // — Quick add (duo + popup) —
  root.querySelectorAll('[data-add-variant]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const original = btn.textContent;
      btn.setAttribute('disabled', 'disabled');
      addToCart(btn.dataset.addVariant, 1, null)
        .then(() => { btn.textContent = T.added; setTimeout(() => { btn.removeAttribute('disabled'); btn.textContent = original; }, 1400); })
        .catch(() => { btn.textContent = T.error; setTimeout(() => { btn.removeAttribute('disabled'); btn.textContent = original; }, 1600); });
    });
  });

  // — Galerie héro : vraies photos produit (clic miniature ou swipe sur la photo) —
  const gal = root.querySelector('[data-edf-gal]');
  const galImg = root.querySelector('[data-edf-gal-img]');
  const galThumbs = [...root.querySelectorAll('[data-edf-gal-thumb]')];
  let galIndex = 0;
  function setPhoto(i) {
    if (!galImg || !galThumbs.length) return;
    galIndex = (i % galThumbs.length + galThumbs.length) % galThumbs.length;
    galThumbs.forEach((b, k) => b.classList.toggle('active', k === galIndex));
    const src = galThumbs[galIndex].dataset.edfGalThumb;
    if (!src || galImg.src === src) return;
    // petit fondu : on change la source au creux de l'opacité
    galImg.classList.add('is-fading');
    setTimeout(() => {
      // T6.2 (06/09/2026) : l'image LCP porte un srcset ; sans le retirer, le navigateur garderait la première photo
      galImg.removeAttribute('srcset'); galImg.removeAttribute('sizes');
      galImg.src = src;
      galImg.onload = () => galImg.classList.remove('is-fading');
    }, 160);
  }
  galThumbs.forEach((btn, k) => btn.addEventListener('click', () => setPhoto(k)));
  if (gal && galThumbs.length > 1) {
    let sx = 0, sy = 0, tracking = false;
    gal.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      if (!t) return;
      sx = t.clientX; sy = t.clientY; tracking = true;
    }, { passive: true });
    gal.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      if (!tracking || !t) return;
      tracking = false;
      const dx = t.clientX - sx, dy = t.clientY - sy;
      // seuil + dominance horizontale : ne pas confondre avec le scroll vertical
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) setPhoto(galIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  // — Tabs composition / utilisation —
  root.querySelectorAll('[data-edf-tabs]').forEach((tabs) => {
    const btns = [...tabs.querySelectorAll('[data-edf-tab]')];
    btns.forEach((btn) => btn.addEventListener('click', () => {
      btns.forEach((b) => b.setAttribute('aria-selected', String(b === btn)));
      tabs.querySelectorAll('[data-edf-panel]').forEach((p) => p.classList.toggle('on', p.dataset.edfPanel === btn.dataset.edfTab));
    }));
  });

  // — Apparitions au scroll —
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.2 });
  root.querySelectorAll('.edf-reveal').forEach((el) => io.observe(el));

  // 02/11 (perf) : exécute f une fois la page chargée et le navigateur au repos
  const apresChargement = (f) => { const go = () => (window.requestIdleCallback || ((g) => setTimeout(g, 200)))(f); if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true }); };

  // — Parallaxe des bandes photo pleine largeur (06/08/2026) —
  //   L'image est surdimensionnée en CSS ; on ne fait ici que décaler sa position
  //   verticale selon l'avancement de la bande dans le viewport. Tout est écrit
  //   dans une variable CSS, donc le CSS garde la main sur l'effet (et le désactive
  //   seul en prefers-reduced-motion). Lecture groupée dans un rAF pour éviter le
  //   layout thrashing sur mobile.
  const bandes = [...root.querySelectorAll('.edf-bande')];
  if (bandes.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let enCours = false;
    const placer = () => {
      enCours = false;
      const h = innerHeight;
      bandes.forEach((b) => {
        const r = b.getBoundingClientRect();
        if (r.bottom < -200 || r.top > h + 200) return;
        // -1 quand la bande arrive par le bas, +1 quand elle sort par le haut
        const avance = (r.top + r.height / 2 - h / 2) / (h / 2 + r.height / 2);
        b.style.setProperty('--edf-par', (avance * -26).toFixed(1) + 'px');
      });
    };
    const planifier = () => { if (!enCours) { enCours = true; requestAnimationFrame(placer); } };
    addEventListener('scroll', planifier, { passive: true });
    addEventListener('resize', planifier, { passive: true });
    // 02/11 (perf) : première mesure au repos après le chargement, plus pendant le premier rendu (mise en page forcée)
    apresChargement(planifier);
  }

  // — Confirmation du code promo campagne (TIKTOK10) : rendre visible la remise
  //   appliquée en silence par /discount/TIKTOK10 (utm paid, cookie ou session) —
  const codeOk = root.querySelector('[data-edf-code-ok]');
  if (codeOk) {
    const q = new URLSearchParams(location.search);
    const fromPaid = q.get('utm_source') === 'tiktok' && q.get('utm_medium') === 'paid';
    const cookieCode = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1] || '';
    let seen = false;
    try { seen = sessionStorage.getItem('edTiktok10') === '1'; } catch (e) { /* navigation privée */ }
    if (fromPaid || /tiktok10/i.test(decodeURIComponent(cookieCode)) || seen) {
      codeOk.hidden = false;
      try { sessionStorage.setItem('edTiktok10', '1'); } catch (e) { /* navigation privée */ }
    }
  }

  // — Sticky bar : visible après le héro —
  const sticky = root.querySelector('[data-edf-sticky]');
  const hero = root.querySelector('.edf-hero');
  if (sticky && hero) {
    new IntersectionObserver((entries) => {
      entries.forEach((e) => sticky.classList.toggle('show', !e.isIntersecting));
    }, { threshold: 0.15 }).observe(hero);
  }

  if (reduced) return;

  // — Parallaxe de la grande phrase du Moment cinématique : elle glisse plus
  //   lentement que le scroll (transform seul ; le centrage est fait par translate) —
  const par = root.querySelector('[data-edf-par]');
  if (par) {
    let parTick = false;
    const onParScroll = () => {
      if (parTick) return;
      parTick = true;
      requestAnimationFrame(() => {
        const r = par.parentElement.getBoundingClientRect();
        // -1 → 1 selon la position de la section dans le viewport
        const p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        par.style.transform = 'translateY(' + (p * 34).toFixed(1) + 'px)';
        parTick = false;
      });
    };
    addEventListener('scroll', onParScroll, { passive: true });
    apresChargement(onParScroll);
  }

  // — Inclinaison du tube au pointeur (scène du Moment 1 sur la fiche, héro sur le funnel) —
  const stage = root.querySelector('[data-edf-stage]');
  const scene = root.querySelector('[data-edf-scene]');
  if (scene && stage) {
    let tx = 0, cx = 0, ty = 0, cy = 0;
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
    });
    stage.addEventListener('pointerleave', () => { tx = 0; ty = 0; });
    // 02/11 (perf) : la boucle ne tourne que pendant l'interaction (avant : une image sur deux toute la vie de la page)
    let tiltOn = false;
    const tilt = () => {
      if (Math.abs(tx - cx) > 0.0005 || Math.abs(ty - cy) > 0.0005) {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        scene.style.transform = 'rotateY(' + (cx * 14) + 'deg) rotateX(' + (-cy * 8) + 'deg)';
        requestAnimationFrame(tilt);
      } else tiltOn = false;
    };
    const lancerTilt = () => { if (!tiltOn) { tiltOn = true; requestAnimationFrame(tilt); } };
    stage.addEventListener('pointermove', lancerTilt);
    stage.addEventListener('pointerleave', lancerTilt);
  }
})();

/* ===== Recherche instantanée du blog (06/08/2026) =====
   Filtre les cartes déjà rendues sur la page. Volontairement côté client : le
   blog tient sur quelques pages paginées, et une requête serveur par frappe
   serait un mauvais compromis. Pour chercher au-delà de la page courante,
   l'utilisateur valide et tombe sur la recherche Shopify native (le formulaire
   poste sur /search avec type=article) — ce qui rend aussi la recherche
   utilisable sans JavaScript. */
(function () {
  const form = document.querySelector('[data-edbl-search]');
  if (!form) return;
  const input = form.querySelector('[data-edbl-input]');
  const cartes = [...document.querySelectorAll('[data-edbl-card]')];
  const rien = document.querySelector('[data-edbl-none]');
  if (!input || !cartes.length) return;

  // « émail » et « email » doivent matcher : on compare sans accents.
  // ̀-ͯ = les diacritiques combinants isolés par la décomposition NFD.
  // Écrit en échappements plutôt qu'en caractères littéraux : ces derniers sont
  // invisibles dans un éditeur et se perdent au moindre passage d'outil.
  const sansAccent = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const index = cartes.map((c) => sansAccent((c.dataset.edblT || '').toLowerCase()));

  let t;
  const filtrer = () => {
    const q = sansAccent(input.value.trim().toLowerCase());
    let visibles = 0;
    cartes.forEach((c, i) => {
      const ok = !q || index[i].includes(q);
      c.hidden = !ok;
      if (ok) visibles++;
    });
    if (rien) rien.hidden = !(q && visibles === 0);
  };

  input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(filtrer, 120); });
  // Entrée avec un résultat unique : on y va directement plutôt que de recharger
  // une page de recherche pour un seul article.
  form.addEventListener('submit', (e) => {
    const visibles = cartes.filter((c) => !c.hidden);
    if (input.value.trim() && visibles.length === 1) {
      e.preventDefault();
      location.href = visibles[0].href;
    }
  });
})();

/* ---------------------------------------------------------------------------
 * Compte a rebours de fin de promo (20/09/2026, benchmark § 4 C).
 * La date vient du thème (`data-fin`, ISO avec fuseau) et doit être exactement
 * celle de la remise Shopify — ici 2026-09-27T21:59:59Z. Aucune urgence
 * inventée : si la date est passée ou illisible, l'élément reste vide et
 * invisible, et le bandeau du haut s'éteint de son côté le 28/09.
 * Le gabarit rend l'élément vide : sans JS, rien ne s'affiche, et la phrase
 * « jusqu'au dimanche 27 septembre » reste lisible juste avant.
 * ------------------------------------------------------------------------- */
(() => {
  const el = document.querySelector('[data-edf-countdown]');
  if (!el) return;
  const fin = Date.parse(el.dataset.fin || '');
  if (!fin) return;

  const gabarit = el.dataset.tEnds || '';   // « Fin dans {time} »
  const uJ = el.dataset.uD || 'j';
  const uH = el.dataset.uH || 'h';
  const uM = el.dataset.uM || 'min';
  if (!gabarit.includes('{time}')) return;

  const rendre = () => {
    const reste = fin - Date.now();
    if (reste <= 0) { el.textContent = ''; el.hidden = true; return false; }
    const min = Math.floor(reste / 60000);
    const h = Math.floor(min / 60);
    const j = Math.floor(h / 24);
    const temps = j >= 1
      ? j + ' ' + uJ + ' ' + (h % 24) + ' ' + uH
      : (h >= 1 ? h + ' ' + uH + ' ' + (min % 60) + ' ' + uM : (min % 60) + ' ' + uM);
    el.textContent = gabarit.replace('{time}', temps);
    el.hidden = false;
    return true;
  };

  if (rendre()) setInterval(rendre, 60000);
})();
